<template>
    <div class="modal fade" id="coverageModal" ref="coverageModal" tabindex="-1" aria-labelledby="coverageModal"
        aria-hidden="true">
        <div
            class="modal-dialog modal-dialog-centered mobile:!px-1.5 tablet:!px-0 mobile:!max-w-full tablet:!w-[500px] laptop:!w-[600px] !absolute tablet:!right-4 !top-0 !m-0 h-full">
            <div class="modal-content">
                <div class=" mobile:!p-2.5 !pb-5">
                    <div class="relative">
                        <button type="button"
                            class="absolute top-3 right-2 tablet:right-4 w-6 h-6 z-50 focus:!outline-none focus:!shadow-none"
                            data-bs-dismiss="modal" aria-label="Close">
                            <img src="../../../assets/images/modal-cross-icon.svg" alt="Cross Icon"
                                class="w-[20px] sm:min-w-[30px] h-[20px] sm:min-h-[30px] object-contain">
                        </button>
                        <div
                            class="rounded-lg overflow-hidden h-[80px] bg-customBlue-100 flex flex-col justify-center gap-1 p-3 w-full">
                            <h4 class="text-[18px] sm:text-[20px] font-semibold font-poppins m-0 text-white">
                                Review Coverage Amount (Annual) 

                            </h4>
                        </div>
                    </div>
                    <div class="font-poppins px-1.5 tablet:px-2.5 pt-2.5 pb-[15px]">
                        <div class="pb-[10px] tablet:pb-[25px] pt-[5px] tablet:pt-[15px]">
                            <h4 class="text-sm tablet:text-base font-semibold tablet:mb-1.5 text-[#2459A8]">
                                APPLIANCE AND SYSTEM COMPONENTS:
                            </h4>
                            <p class="font-poppins text-xs tablet:text-sm text-[#333333]">
                                Major brands are covered under this Agreement, subject to part availability. Only listed
                                items are eligible. We reserve the
                                right to decline coverage for items not specifically maintained.
                            </p>
                        </div>
                        <div ref="scrollBox" class="max-h-[500px] customScrollbar pr-1">
                            <div v-for="(obj, index) in data" :key="obj.index"
                                class="bg-[#E5D2B4]/15 p-[10px] tablet:p-[20px] rounded-[10px]"
                                :class="index !== 0 ? 'mt-[15px]' : ''">

                                <!-- Plan Header -->
                                <div class="mb-3">
                                    <h3 class="mb-1.5 font-poppins text-[18px] tablet:text-[20px] font-bold text-customBlue-100">{{ obj.planName }}</h3>
                                    <p class="font-poppins text-[12px] tablet:text-[14px] text-[#333333]" v-html="obj.caption" v-if="obj.caption">
                                    </p>
                                </div>

                                <!-- Categories -->
                                <div v-for="(cat, cIndex) in obj.category" :key="cIndex">

                                    <!-- Category Header -->
                                    <div v-if="cat.title"
                                        class="flex items-center justify-between gap-2.5 pb-2.5 " :class="cIndex == 1 ? 'mt-[20px]' : '' ">

                                        <div class="flex items-center gap-2" >
                                            <span v-if="cIndex == 0"
                                                class="h-[30px] w-[30px] flex items-center justify-center font-semibold text-white rounded-full bg-[#F5B134]">
                                                1
                                            </span>
                                            <span v-if="cIndex == 1"
                                                class="h-[30px] w-[30px] flex items-center justify-center font-semibold text-white rounded-full bg-[#F5B134]">
                                                2
                                            </span>

                                            <h4 class="font-semibold text-xs tablet:text-sm text-[#333333]">
                                                {{ cat.title }}
                                            </h4>
                                        </div>

                                        <span class="text-base tablet:text-lg font-bold text-right pr-[10px] min-w-[80px] text-[#2459A8]">
                                            {{ cat.total }}
                                        </span>
                                    </div>

                                    <!-- Items -->
                                    <ul class="flex flex-col gap-2.5 border-t border-[#CCCCCC] pt-[10px]">
                                        <li v-for="(item, i) in cat.items" :key="i"
                                            class="flex items-center justify-between gap-2 rounded-[5px] py-2.5 px-2.5 bg-white">

                                            <div class="flex items-start gap-2.5">
                                                <img src="../../../assets/images/share-img.png"
                                                    class="h-[16px] w-[16px] object-cover tablet:mt-0.5" alt="icon" />

                                                <p class="text-xs tablet:text-sm font-medium">
                                                    {{ item.title }}
                                                </p>
                                            </div>

                                            <span class="min-w-[70px] text-right text-base tablet:text-lg font-bold text-[#333333]">
                                                {{ item.total }}
                                            </span>
                                        </li>
                                    </ul>

                                </div>
                                <ul class="flex flex-col gap-2.5 pt-[10px]">
                                    <li v-for="(item, index) in obj.items" :key="index"
                                        class="flex items-center justify-between gap-2 tablet:gap-3 rounded-[5px] py-2.5 px-2.5 bg-white">
                                        <div class="flex items-start gap-3"> <img
                                                src="../../../assets/images/share-img.png"
                                                class="h-[16px] w-[16px] object-cover tablet:mt-0.5" alt="icon">
                                            <p class="text-xs tablet:text-sm font-medium">{{ item.title }}:</p>
                                        </div> 
                                        <span
                                            class="min-w-[100px] tablet:min-w-[150px] text-right text-base tablet:text-lg font-bold text-[#333333]">{{
                                            item.total }}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Modal } from "bootstrap";
import { disableScroll, enableScroll } from "../../../helpers/scrollHelper";

export default {
    data() {
        return {
            data: [
                {
                    index: "1",
                    planName: "Deluxe Coverage Plan",
                    caption: "The Deluxe Coverage Plan protects your major systems and appliances.<br> Coverage is shown separately for Cooling/Heating Systems and for Appliances & Other Systems.",
                    category: [
                        {
                            title: "COOLING/HEATING SYSTEMS:",
                            total: "",
                            items: [
                                {
                                    title: "Central Air Conditioning (Includes Heat Pumps – Electric Only)",
                                    total: "$3,000"
                                },
                                {
                                    title: "Central Home Heating (Gas or Electric)",
                                    total: "$3,000"
                                }
                            ]
                        },
                        {
                            title: "APPLIANCES AND OTHER SYSTEMS:",
                            total: "",
                            items: [
                                { title: "Built-In Microwave", total: "$1,000" },
                                { title: "Dishwasher", total: "$1,000" },
                                { title: "Garbage Disposal", total: "$1,000" },
                                { title: "Kitchen Refrigerator", total: "$1,000" },
                                { title: "Range/Oven/Cooktop", total: "$1,000" },
                                { title: "Clothes Washer", total: "$1,000" },
                                { title: "Water Heater", total: "$1,000" },
                                { title: "Ceiling Fans", total: "$1,000" },
                                { title: "Doorbell System", total: "$1,000" },
                                { title: "Kitchen Exhaust Fan", total: "$1,000" },
                                { title: "Internal Plumbing System", total: "$1,000" },
                                { title: "Fixtures", total: "$1,000" },
                                { title: "Internal Stoppages", total: "$1,000" },
                                { title: "Toilet Repairs", total: "$1,000" },
                                { title: "Electric", total: "$1,000" },
                                { title: "Internal Electrical System", total: "$1,000" },
                            ]

                        },]
                },
                {
                    index: "2",
                    planName: "Optional Coverages",
                    caption: "The amounts below show the coverage for each optional plan.<br> Optional coverages must be purchased separately and are not included with the Deluxe Coverage Plan.",
                    category: [
                        {
                            items: [
                                {
                                    title: "Free-Standing Freezer",
                                    total: "$1,000"
                                },
                                {
                                    title: "Programmable Thermostat",
                                    total: "$1,000"
                                },
                                {
                                    title: "Well Pump",
                                    total: "$1,000"
                                },
                                {
                                    title: "Swimming Pool",
                                    total: "$1,000"
                                },
                                {
                                    title: "Garage Door Opener",
                                    total: "$1,000"
                                },
                                {
                                    title: "Additional AC Unit",
                                    total: "$3,000"
                                },
                                {
                                    title: "Ice Maker",
                                    total: "$1,000"
                                },
                                {
                                    title: "Wine Cooler",
                                    total: "$1,000"
                                },
                                {
                                    title: "Secondary Refrigerator",
                                    total: "$1,000"
                                },
                                {
                                    title: "Septic System",
                                    total: "$1,000"
                                },
                            ]
                        },
                    ]
                }
            ]
        };
    },
    props: {
        cartmodalOpen: {
            type: Boolean,
            default: false
        }
    },
    components: {

    },

    computed: {

    },
    watch: {


    },

    mounted() {

    },

    unmounted() {
        enableScroll();
    },

    methods: {

        openModal() {
            if (this.modal) return
            const modalEl = this.$refs.coverageModal;

            // Create bootstrap modal
            this.modal = new Modal(modalEl, { backdrop: 'static' });
            disableScroll();
            this.adjustPlanModalHeight();
            window.addEventListener('resize', this.adjustPlanModalHeight);
            window.addEventListener('orientationchange', this.adjustPlanModalHeight);
            // Fix scroll restore on close
            modalEl.addEventListener("hidden.bs.modal", () => {
                if (this.cartmodalOpen === false) {
                    enableScroll();
                }
                this.modal = null
                window.addEventListener('resize', this.adjustPlanModalHeight);
                window.addEventListener('orientationchange', this.adjustPlanModalHeight);
            });

            modalEl.addEventListener("shown.bs.modal", () => {
                if (this.$refs.scrollBox) {
                    this.$refs.scrollBox.scrollTo({ top: 0, behavior: "smooth" });
                }
            });


            if (window.innerWidth > 992) {
                // disableScroll() // already called above
            }
            this.modal.show();
            this.$nextTick(() => {
                this.$refs.scrollBox.scrollTop = 0;
            });


        },

        closeModal() {
            if (this.modal == null) return
            // Tailwind way → enable scroll
            if (window.innerWidth > 992) {
                enableScroll();
            }

            this.modal.hide();
        },

        adjustPlanModalHeight() {
            const modalContent = this.$refs.scrollBox;
            if (modalContent) {
                const vh = window.innerHeight;
                const vw = window.innerWidth;
                let maxHeight;
                if (vw < 300) {
                    maxHeight = vh * 0.6 - 40;
                } else if (vw < 768) {
                    maxHeight = vh * 0.6 - 50;
                } else if (vw < 991) {
                    maxHeight = vh * 0.6 - 50;
                } else if (vw < 1440) {
                    maxHeight = vh * 0.6 - 70;
                }
                else {
                    maxHeight = vh * 0.7 - 100;
                }
                modalContent.style.maxHeight = `${maxHeight}px`;
                modalContent.style.overflowY = 'auto';
            }
        },

    },
};
</script>
